import ProjectContractForm from './project_contract-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
import {FileInput} from '@/components/refinedev/FileInput';
import EditForm from '@/components/refinedev/pages/edit-form';
import RichTextInput from '@/components/refinedev/RichTextInput';
import Section from '@/components/surface/Section';
import {convertArrayField} from '@/pages/_utils';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/shadcn_components/ui/tabs';

const ProjectContractEdit = () => {
  return (
    <EditForm
      transformBeforeSave={data => ({
        ...ProjectContractForm.transformBeforeSave(data),
        attachments: convertArrayField(data?.attachments),
      })}
      formProps={{
        refineCoreProps: {
          meta: {
            with: [],
            append: ['attachments'],
          },
        },
      }}>
      <div className="max-w-3xl mx-auto flex flex-col gap-y-4 ">
        <Tabs defaultValue="general_info">
          <TabsList className="flex gap-x-4">
            <TabsTrigger value="general_info">Thông tin chung</TabsTrigger>
            <TabsTrigger value="contents">Nội dung</TabsTrigger>
            <TabsTrigger value="documents">Tài liệu đính kèm</TabsTrigger>
          </TabsList>

          <TabsContent value="general_info" forceMount>
            <Section
              title="Thông tin hợp đồng"
              bodyProps={{className: 'flex flex-col gap-2'}}
              className="mx-auto">
              <ProjectContractForm.GeneralInfo />
            </Section>
          </TabsContent>

          <TabsContent value="contents" forceMount>
            <Section
              className="mx-auto"
              title="Nội dung hợp đồng"
              subtitle="Nội dung chi tiết của hợp đồng">
              <RichTextInput source="content" label="Nội dung" />
            </Section>
          </TabsContent>

          <TabsContent value="documents" forceMount>
            <Section
              title="Tài liệu đính kèm"
              subtitle="Tài liệu hợp đồng"
              className="mx-auto">
              <FileInput source="attachments" label="File đính kèm" multiple />
            </Section>
          </TabsContent>
        </Tabs>
        <SaveButton size="lg" className="self-end" />
      </div>
    </EditForm>
  );
};

export default ProjectContractEdit;
